import React, { useState, useMemo } from "react";
import {
    Box,
    Typography,
    IconButton,
    Dialog,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchInput from "../../../components/SearchInput";
import { Card } from "../../../components/Card";
import { useNavigate } from "react-router-dom";
import useSWR from "swr";
import API_ENDPOINTS from "../../../apis/endpoints";
import ThumbnailTemplate from "../../../assets/images/Newsletter Thumbnail.png";

function TenmplatePopup({ open, onClose }) {
    const { data, error, isLoading } = useSWR(
        `${API_ENDPOINTS.NEWSLETTER}templates/`
    );

    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();

    const handleSearch = (term) => {
        setSearchTerm(term);
    };

    const handleTemplateSelect = (template) => {
        navigate(
            `/dashboard/newsletter/create${
                template?.id ? `?template=${template.id}` : ""
            }`
        );
        onClose();
    };

    const filteredTemplates = useMemo(() => {
        if (!data) return { user: [], public: [] };

        const filterTemplates = (templates) =>
            templates.filter((template) =>
                template.name.toLowerCase().includes(searchTerm.toLowerCase())
            );

        return {
            user: filterTemplates(data.user),
            public: filterTemplates(data.public),
        };
    }, [data, searchTerm]);

    const TemplateCard = ({ template, isBlank = false }) => {
        const getCorrectImageUrl = (url) => {
            if (url?.startsWith("http://") || url?.startsWith("https://")) {
                return url;
            }
            return `https://${url}`;
        };

        return (
            <Box
                onClick={() => handleTemplateSelect(template)}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "15rem",
                    cursor: "pointer",
                    justifyContent: "center",
                    alignSelf: "center",
                }}
            >
                <Box
                    sx={{
                        height: "14rem",
                        width: "100%",
                        border: isBlank
                            ? "2px dashed gray"
                            : "1px solid lightgray",
                        borderRadius: 2,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#f9f9f9",
                    }}
                >
                    {isBlank ? (
                        <Typography
                            variant="h4"
                            sx={{ fontWeight: "bold", color: "graph.cyan" }}
                        >
                            +
                        </Typography>
                    ) : (
                        <img
                            src={ThumbnailTemplate}
                            alt={template.name}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                objectPosition: "top",
                                borderRadius: "16px",
                            }}
                        />
                    )}
                </Box>
                <Typography variant="body2" sx={{ mt: 1, textAlign: "center" }}>
                    {isBlank ? "Blank Template" : template.name}
                </Typography>
            </Box>
        );
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            sx={{
                ".MuiPaper-root": {
                    borderRadius: 3,
                },
            }}
        >
            <DialogTitle
                sx={{ display: "flex", justifyContent: "space-between" }}
            >
                <Typography variant="h6">Select Template</Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography
                    variant="body1"
                    color="textSecondary"
                    sx={{ mb: 3 }}
                >
                    You can start with a new fresh template as a blank one or
                    select from other templates below.
                </Typography>
                <SearchInput
                    onSearch={handleSearch}
                    placeHolder={"Template..."}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    sx={{ width: "53rem" }}
                />
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns:
                            "repeat(auto-fill, minmax(32%, 1fr))",
                        gap: 1,
                        justifyContent: "center",
                        mt: "2rem",
                        width: "100%",
                        alignItems: "center",
                    }}
                >
                    <TemplateCard key={0} isBlank={true} />
                    {filteredTemplates.user.map((template) => (
                        <TemplateCard key={template.id} template={template} />
                    ))}
                    {filteredTemplates.public.map((template) => (
                        <TemplateCard key={template.id} template={template} />
                    ))}
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default TenmplatePopup;
